<div
  *ngIf="rule && treeNodes && treeNodes.length > 0"
  class="schema-container"
  [class.schema-container--editable]="effectiveCanEdit"
>
  <p-treeTable [value]="treeNodes" [scrollable]="true" scrollHeight="600px">
    <ng-template pTemplate="header">
      <tr>
        <th scope="col" style="width: 300px; max-width: 300px">
          {{ "WXRL.SCHEMA.ELEMENTO" | translate }}
        </th>
        <th scope="col">{{ "WXRL.SCHEMA.DESCRIPCION_DETALLE" | translate }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
      <tr
        [class.wxrl-schema-action-row--non-active]="
          isTreeTableStateRowMuted(rowData)
        "
      >
        <td>
          <div class="element-content">
            <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
            <span
              class="element-label"
              [class.element-bold]="
                rowData.type === 'section' || rowData.type === 'rule'
              "
              >{{ rowData.elemento }}</span
            >
            <span
              *ngIf="treeTableRuleStateBadgeVisible(rowData)"
              class="wxrl-schema-rule-state-badge"
              [class.wxrl-schema-rule-state-badge--muted]="
                isTreeTableStateRowMuted(rowData)
              "
              [pTooltip]="treeTableRuleStateTooltip(rowData)"
              tooltipPosition="top"
              [tooltipOptions]="{ appendTo: 'body' }"
              >{{ treeTableRuleStateLabelForRow(rowData) }}</span
            >
            <div
              class="action-buttons"
              *ngIf="
                rowData.type !== 'section' &&
                rowData.type !== 'rule' &&
                rowData.type !== 'action-summary' &&
                effectiveCanEdit
              "
            >
              <p-button
                *ngIf="rowData.type !== 'trigger'"
                icon="pi pi-arrow-up"
                [text]="true"
                [rounded]="true"
                size="small"
                [disabled]="isFirstItem(rowData)"
                [pTooltip]="'WXRL.SCHEMA.SUBIR' | translate"
                (click)="onMoveUp(rowData); $event.stopPropagation()"
              ></p-button>
              <p-button
                *ngIf="rowData.type !== 'trigger'"
                icon="pi pi-arrow-down"
                [text]="true"
                [rounded]="true"
                size="small"
                [disabled]="isLastItem(rowData)"
                [pTooltip]="'WXRL.SCHEMA.BAJAR' | translate"
                (click)="onMoveDown(rowData); $event.stopPropagation()"
              ></p-button>
              <p-button
                icon="pi pi-pencil"
                [text]="true"
                [rounded]="true"
                size="small"
                [pTooltip]="'WXRL.SCHEMA.EDITAR' | translate"
                (click)="onEdit(rowData); $event.stopPropagation()"
              ></p-button>
              <p-button
                icon="pi pi-trash"
                [text]="true"
                [rounded]="true"
                size="small"
                severity="danger"
                [pTooltip]="'WXRL.SCHEMA.ELIMINAR' | translate"
                (click)="onDelete(rowData); $event.stopPropagation()"
              ></p-button>
              <p-button
                icon="pi pi-clipboard"
                [text]="true"
                [rounded]="true"
                size="small"
                [pTooltip]="'WXRL.SCHEMA.DETALLES' | translate"
                (click)="$event.stopPropagation()"
              ></p-button>
            </div>
            <p-button
              *ngIf="
                (rowData.type === 'section' || rowData.type === 'rule') &&
                effectiveCanEdit
              "
              icon="pi pi-plus"
              [text]="true"
              [rounded]="true"
              size="small"
              class="add-button"
              [pTooltip]="'WXRL.SCHEMA.ANADIR' | translate"
              (click)="onAdd(rowData); $event.stopPropagation()"
            ></p-button>
          </div>
        </td>
        <td>
          <pre
            class="detail-text"
            [class.detail-normal]="
              rowData.type !== 'section' && rowData.type !== 'rule'
            "
            [pTooltip]="rowData.actionLabelTooltip"
            [tooltipDisabled]="!rowData.actionLabelTooltip"
            tooltipPosition="left"
            [tooltipOptions]="{ appendTo: 'body' }"
            >{{ rowData.detalle }}</pre
          >
        </td>
      </tr>
    </ng-template>
  </p-treeTable>
</div>
<div *ngIf="!rule || !treeNodes || treeNodes.length === 0" class="no-data">
  {{ "WXRL.SCHEMA.NO_DATA" | translate }}
</div>

<!-- Drawer de Condición -->
<afoone-wxrl-condition-drawer
  [(visible)]="conditionDrawerVisible"
  [condition]="editingCondition"
  [initialCondRule]="initialCondRule"
  [isEditMode]="isEditModeCondition"
  [actuaSobreOptions]="actuaSobreOptions"
  [perfilOptions]="perfilOptions"
  [tipoResOptions]="tipoResOptions"
  [aislamientoOptions]="aislamientoOptions"
  [labNr]="effectiveLabNrForChildren"
  [labType]="labType || ''"
  [isNewRule]="isNewRule"
  (save)="onSaveConditionFromDrawer($event)"
  (cancel)="closeConditionDrawer()"
></afoone-wxrl-condition-drawer>


<!-- Drawer de Acción -->
<afoone-wxrl-action-drawer
  [(visible)]="actionDrawerVisible"
  [action]="editingAction"
  [isEditMode]="isEditModeAction"
  [actionStates]="actionStates"
  [actionTypes]="actionTypes"
  [labNr]="effectiveLabNrForChildren"
  [actionHeader]="rule?.actionHeader"
  [existingRuleActionOptions]="ruleActionOptions"
  [nextStepNumber]="nextActionPosA"
  [isNewRule]="isNewRule"
  (save)="onSaveActionFromDrawer($event)"
  (requestLoadAction)="onRequestLoadExistingAction($event)"
  (cancel)="closeActionDrawer()"
></afoone-wxrl-action-drawer>

<!-- Drawer de Disparador -->
<afoone-wxrl-trigger-drawer
  [(visible)]="triggerDrawerVisible"
  [trigger]="editingTrigger"
  [isEditMode]="isEditModeTrigger"
  [labNr]="labNr"
  [labType]="labType"
  [isNewRule]="isNewRule"
  (save)="onSaveTriggerFromDrawer($event)"
  (triggerCancel)="closeTriggerDrawer()"
></afoone-wxrl-trigger-drawer>

<!-- Drawer de Cabecera -->
<afoone-wxrl-header-drawer
  [(visible)]="headerDrawerVisible"
  [headerData]="editingHeaderData"
  [conditions]="getConditionsForFormulaEditor()"
  [isNewRule]="isNewRule"
  [cancelKeepsDrawerOpen]="headerDrawerFirstAccessUx"
  (save)="onSaveHeaderFromDrawer($event)"
  (cancel)="onHeaderDrawerCancel()"
  (clearConditions)="onClearConditionsFromHeaderDrawer()"
></afoone-wxrl-header-drawer>

<!-- Drawer de Fórmula (solo para nueva regla) -->
<afoone-wxrl-formula-drawer
  [(visible)]="formulaDrawerVisible"
  [formula]="ruleForm?.value?.condition || ''"
  [negRule]="ruleForm?.value?.negRule || false"
  [conditions]="getConditionsForFormulaEditor()"
  (saveAndFinish)="onSaveFormulaAndFinish($event)"
  (cancel)="closeFormulaDrawer()"
></afoone-wxrl-formula-drawer>

<p-confirmDialog [appendTo]="'body'"></p-confirmDialog>
